import React from 'react';
import c from 'classnames';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import s from './PopoverHeadingText.scss';
/** Our standard popover heading text */ const PopoverHeadingText = ({ className , isSubheading , children ,  })=>/*#__PURE__*/ React.createElement(Heading, {
        className: c(s['root'], isSubheading && s['subheading'], className)
    }, children);
PopoverHeadingText.displayName = 'PopoverHeadingText';
export default PopoverHeadingText;
